/**
 * Updates price and discount display when a subscription plan is selected. This in product cards.
 * Sets the correct selling plan ID for form submission.
 *
 * @param {Object} args
 * @param {string} args.selectId - ID of the subscription <select>.
 * @param {number} args.basePrice - Base price in cents.
 * @param {string} args.priceSpanId - ID of span showing discounted price.
 * @param {string} args.discountSpanId - ID of span showing % discount.
 * @param {string} args.hiddenInputId - ID of hidden selling_plan input.
 */

// function updateSubscriptionPrice({ selectId, basePrice, priceSpanId, discountSpanId, hiddenInputId }) {
//   const select = document.getElementById(selectId);
//   const selected = select.options[select.selectedIndex];
//   const discountPercent = parseFloat(selected.dataset.discount);
//   const priceSpan = document.getElementById(priceSpanId);
//   const discountSpan = document.getElementById(discountSpanId);
//   const hiddenInput = document.getElementById(hiddenInputId);

//   if (!isNaN(discountPercent)) {
//     const discountAmount = (basePrice * discountPercent) / 100;
//     const newPrice = (basePrice - discountAmount) / 100;

//     priceSpan.textContent = newPrice.toFixed(2).replace('.', ',');
//     discountSpan.textContent = discountPercent.toFixed(2);
//     hiddenInput.value = selected.value;
//   }
// }

function updateSubscriptionPrice({ selectId, basePrice, priceSpanId, discountSpanId, hiddenInputId }) {
  const select = document.getElementById(selectId);
  const selected = select.options[select.selectedIndex];
  const discountPercent = parseFloat(selected.dataset.discount);
  const priceSpan = document.getElementById(priceSpanId);
  const discountSpan = document.getElementById(discountSpanId);
  const hiddenInput = document.getElementById(hiddenInputId);

  if (!isNaN(discountPercent)) {
    const discountAmount = (basePrice * discountPercent) / 100;
    const newPrice = (basePrice - discountAmount) / 100;

    priceSpan.textContent = newPrice.toFixed(2).replace('.', ',');
    discountSpan.textContent = (discountAmount / 100).toFixed(2).replace('.', ',');
    hiddenInput.value = selected.value;
  }
}


/**
 * Enables or disables the selling_plan input based on purchase type.
 *
 * @param {Object} args
 * @param {string} args.productId - Product ID.
 * @param {boolean} args.enable - True for subscription, false for one-time.
 */

function toggleSellingPlanInput({ productId, enable }) {
  const input = document.getElementById(`selling_plan_input_${productId}`);
  if (!input) return;

  if (enable) {
    input.setAttribute("name", "selling_plan");
    input.value = input.dataset.defaultPlan || "";
  } else {
    input.removeAttribute("name");
    // we set the default plan to the value of the input, so it can be used later
    input.dataset.defaultPlan = input.value;
    input.value = "";
  }
}